module.exports = __webpack_public_path__ + "img/img0.7133dd4f.jpg";